import { render } from "./NoticesTable.vue?vue&type=template&id=047190e0&scoped=true"
import script from "./NoticesTable.vue?vue&type=script&lang=js"
export * from "./NoticesTable.vue?vue&type=script&lang=js"

import "./NoticesTable.vue?vue&type=style&index=0&id=047190e0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047190e0"]])

export default __exports__